<script setup>
import { isUuid } from 'dashboard/composables/usePiiRedaction';

const props = defineProps({
  // [{ label, value, format }] — format: 'text' | 'date' | 'badge'
  fields: { type: Array, default: () => [] },
  // [{ label, active }] — rendered as a row of pill badges
  pills: { type: Array, default: () => [] },
  note: { type: String, default: '' },
});

defineOptions({ name: 'DetailFieldGrid' });

function isDisplayable(value) {
  return (
    value !== null && value !== undefined && value !== '' && !isUuid(value)
  );
}

function formatDate(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

function displayValue(field) {
  if (!isDisplayable(field.value)) return '—';
  if (field.format === 'date') return formatDate(field.value);
  return String(field.value);
}

const visibleFields = props.fields.filter(f => isDisplayable(f.value));
</script>

<template>
  <div>
    <div class="grid grid-cols-3 gap-x-4 gap-y-3">
      <div v-for="field in visibleFields" :key="field.label">
        <p class="text-xs font-medium uppercase tracking-wide text-gray-500">
          {{ field.label }}
        </p>
        <p class="mt-0.5 text-sm text-gray-900">{{ displayValue(field) }}</p>
      </div>
    </div>
    <p v-if="note" class="mt-3 text-sm text-gray-700">{{ note }}</p>
    <div v-if="pills.length" class="mt-4 flex flex-wrap gap-2">
      <span
        v-for="pill in pills"
        :key="pill.label"
        class="inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium"
        :class="
          pill.active
            ? 'border-green-200 bg-green-50 text-green-700'
            : 'border-gray-200 bg-gray-50 text-gray-500'
        "
      >
        {{ pill.label }}
      </span>
    </div>
  </div>
</template>
